export const SUCCESS_MSG_PREFIX = "success-message.";
export const ORDER_ID = "orderid";
export const HYPHEN = "-";
export const SLOTID = "id";
export const SELLER_STORAGE_KEY = "seller";

export const CommerceEnvironment = {
  productSkeleton: {
    id: "",
    type: "Product",
    productInternal: "",
    productDesc: {},
    eSpotInternal: {},
    eSpotDescInternal: {},
  },
  suggestionSkeleton: {
    arrIndex: "",
    id: "",
    type: "Suggestion",
    name: "",
    url: {},
  },
  errorParamsSkeleton: {
    zero: "",
    one: "",
    two: "",
  },
  defaultLang: "de",
  languageToLocaleMap: {
    en: "en_US",
    de: "de_DE",
  } as const,
  localeToLanguageMap: {
    en_US: "en",
    de_DE: "de",
  } as const,
  languageMapShort: {
    "-1": "en",
    "-3": "de",
  } as const,
  reverseLanguageMapShort: {
    en: "-1",
    de: "-3",
  } as const,
};

export type LanguageMapShortType =
  (typeof CommerceEnvironment)["languageMapShort"];
export type LanguageMapShortKeyType = keyof LanguageMapShortType;
export type LanguageMapShortValueType =
  LanguageMapShortType[LanguageMapShortKeyType];

export type LocaleToLanguageMapType =
  (typeof CommerceEnvironment)["localeToLanguageMap"];
export type LocaleToLanguageMapKeyType = keyof LocaleToLanguageMapType;
export type LocaleToLanguageMapValueType =
  LocaleToLanguageMapType[LocaleToLanguageMapKeyType];

export const isSupportedLanguageId = (
  candidate?: string
): candidate is LanguageMapShortKeyType =>
  candidate != null && CommerceEnvironment.languageMapShort[candidate] != null;
